// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../context/user/User_Types_Utils.bs.js";
import * as Messages_Flash_Edit$DvmAdminFrontendFr from "../../../../intl/messages/flash/Messages_Flash_Edit.bs.js";
import * as Flash_Edit_DateInput$DvmAdminFrontendFr from "./Flash_Edit_DateInput.bs.js";

function Flash_Edit_Dates_Spain(Props) {
  var formAdditional = Props.formAdditional;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(match[0].selectedRole) === /* Spain */1) {
    return React.createElement(Core.Grid, {
                children: React.createElement(Flash_Edit_DateInput$DvmAdminFrontendFr.make, {
                      icon: /* CarPark */7,
                      message: Messages_Flash_Edit$DvmAdminFrontendFr.attributionDateVinPeriod,
                      startDateValue: formAdditional.input.attributionVehicleDateStart,
                      startDateOnChange: Curry._1(formAdditional.updateAttributionVehicleDateStart, (function (input, attributionVehicleDateStart) {
                              return {
                                      clientType: input.clientType,
                                      saleType: input.saleType,
                                      dealerIds: input.dealerIds,
                                      dealerWithAgents: input.dealerWithAgents,
                                      attributionVehicleDateStart: attributionVehicleDateStart,
                                      attributionVehicleDateEnd: input.attributionVehicleDateEnd
                                    };
                            })),
                      startDateResult: formAdditional.attributionVehicleDateStartResult,
                      endDateValue: formAdditional.input.attributionVehicleDateEnd,
                      endDateOnChange: Curry._1(formAdditional.updateAttributionVehicleDateEnd, (function (input, attributionVehicleDateEnd) {
                              return {
                                      clientType: input.clientType,
                                      saleType: input.saleType,
                                      dealerIds: input.dealerIds,
                                      dealerWithAgents: input.dealerWithAgents,
                                      attributionVehicleDateStart: input.attributionVehicleDateStart,
                                      attributionVehicleDateEnd: attributionVehicleDateEnd
                                    };
                            })),
                      endDateResult: formAdditional.attributionVehicleDateEndResult,
                      startDateRequired: false,
                      endDateRequired: false
                    }),
                item: true
              });
  } else {
    return null;
  }
}

var make = Flash_Edit_Dates_Spain;

export {
  make ,
}
/* react Not a pure module */
